import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import businessModule from "./modules/business.js";
import accountingFirmModule from "./modules/accountingFirm.js";
import collectDataModule from "./modules/collectData.js";
import documentDataModule from "./modules/documentData.js";
import securityModule from "./modules/security.js";
import businessOperatorModule from "./modules/businessOperator.js";

export default createStore({
  modules: {
    businessModule,
    accountingFirmModule,
    collectDataModule,
    documentDataModule,
    securityModule,
    businessOperatorModule,
  },
  plugins: [
    createPersistedState({
      key: "my-key",
      reducer: (state) => {
        const { processingFlag, ...others } = state;
        return processingFlag;
      },
    }),
  ],
});
